import React from 'react';
import { connect } from 'react-redux';
import {
  addProductToWishlist,
  removeProductFromWishlistPDP
} from '../../../wishlist/actions/wishlist';
import * as actions from '../../../actions/productData';
import { generateEvent } from '../../../utils/dataGrinch';
import { signInCheck } from '../../common/CheckUserStatus';
import { showModal } from '../../../actions/modal.js';
import { buildQuery } from '../../../utils/products';
import { loadWishlistOptionCodesAPI } from '../../../wishlist/actions/wishlist';
import { jioAdsAddtoWishList, jioAdsRemoveFromWishList } from '../../../utils/jioAds';
import properties from '../../../modules/ajio-util/properties';
import { gtmEventPush, segmentEventPush, getProductItemPDP } from '../../../modules/ga/GTMdatalayer';
import { deferNonCriticalWork, deferAfterPaint } from '../../../utils/deferWork';
import wishlistStatusCodes from '../../../utils/wishlistStatusCodes';

const imageBaseUrl = properties.getProperty('imageBaseUrl');

class SaveToCloset extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      display: false,
      productLiked: false,
      closetPop: false
    };
    this.closetInFlight = false;
    this.saveToCloset = this.saveToCloset.bind(this);
  }

  componentDidMount() {
    const {
      loadWishlistOptionCodesAPI,
      data: {
        price: { formattedValue: Price = '', value: priceValue = '' } = {},
        baseProduct = '',
        brickName,
        brickCategory,
        brickSubCategory,
        code: pdCode,
        verticalColor
      }
    } = this.props;
    const prdCode = localStorage.getItem('prdCode');
    const username = signInCheck(true);
    if (username) {
      if (prdCode) {
        this.props.addToWishlistApi(prdCode);
        setTimeout(() => {
          console.log('TRACK POINT 3 ~ brickSubCategory:', brickSubCategory);
          jioAdsAddtoWishList({
            brickCategory,
            brickSubCategory,
            brickName,
            code: pdCode,
            price: priceValue,
            quantity: 1
          });
        }, 500);
        localStorage.removeItem('prdCode');
        setTimeout(() => {
          loadWishlistOptionCodesAPI();
        }, 500);
      }
      this.setGuestUserWishlistStatus();
    }

    const isWishlisted = this.setWishlistStatusFromLocal();
    this.setState({ productLiked: isWishlisted });
  }

  setGuestUserWishlistStatus = () => {
    const { productCode } = this.props;
    const prdColorGroup = localStorage.getItem('prdColorGroup');
    if (prdColorGroup === productCode) {
      setTimeout(() => {
        this.addWishlistInLocal();
        this.setState({ productLiked: true });
        localStorage.removeItem('prdColorGroup');
      }, 1000);
    }
  };

  setWishlistStatusFromLocal = () => {
    const { productCode } = this.props;
    const username = signInCheck(true);
    const wishlistData = JSON.parse(localStorage.getItem('productWishlistStatusData'));
    if (!wishlistData || !username) return false;
    const userWishlistData = wishlistData[username];
    if (!userWishlistData) return false;
    const { codes = [] } = userWishlistData;
    if (codes.length === 0) return false;
    return codes.includes(productCode);
  };

  removeItemFromLocal = code => {
    const localData = JSON.parse(localStorage.getItem('wishlistPriceDrop')) || [];
    for (let i = 0; i <= localData?.length - 1; i++) {
      if (localData[i]?.itemCode === code) {
        localData?.splice(i, 1);
      }
    }
    localStorage.setItem('wishlistPriceDrop', JSON.stringify(localData));
  };

  removeWishlistInLocal = code => {
    const username = signInCheck(true);
    let wishlistData = JSON.parse(localStorage.getItem('productWishlistStatusData'));
    if (!wishlistData || !username) return false;
    const userWishlistData = wishlistData[username];
    if (!userWishlistData) return false;
    const { codes = [], updatedOn } = userWishlistData;
    if (codes.length > 0) {
      const index = codes.indexOf(code);
      if (index >= 0) {
        codes.splice(index, 1);
        const localData = {
          updatedOn,
          codes
        };
        let finalResponse = wishlistData;
        finalResponse[username] = localData;
        localStorage.setItem('productWishlistStatusData', JSON.stringify(finalResponse));
      }
    }
  };

  wishListDeleteCall = (request, code) => {
    const reqQuery = { ...request.query };
    reqQuery.currentPage = 0;
    const query = buildQuery(reqQuery);
    let nextRequest = { ...request, query };
    this.removeItemFromLocal(code);
    this.removeWishlistInLocal(code);
    this.props.removeFromWishlist(code, nextRequest);
  };

  removeWishlistAlreadyExists = () => {
    const { productCode, request = {} } = this.props;
    this.wishListDeleteCall(request, productCode);
    this.setState({ productLiked: false });
  };

  revertClosetAdd = () => {
    const { productCode } = this.props;
    this.removeWishlistInLocal(productCode);
    this.setState({ productLiked: false, closetPop: false });
  };

  revertClosetRemove = () => {
    this.addWishlistInLocal();
    this.setState({ productLiked: true, closetPop: false });
  };

  saveToCloset(prodData, productLiked) {
    if (this.closetInFlight) return;
    const wasLiked = this.state.productLiked;
    const { productCode, selectedSizeName = '' } = this.props;
    let sizeCode = this.props.selectedSizeCode || prodData;
    let {
      newDesignLuxe,
      luxeEventPush,
      data: {
        price: { formattedValue: Price = '', value: priceValue = '' } = {},
        wasPriceData: { value: originalPrice = 0 } = {},
        baseProduct = '',
        brickName,
        brickCategory,
        brickSubCategory,
        code: pdCode,
        verticalColor,
        name = ''
      }
    } = this.props;
    const dataSnapshot = this.props.data;
    const sizeCodeAtClick = sizeCode;
    const productLikedAtClick = productLiked;
    let isSignedIn = signInCheck();
    if (isSignedIn && wasLiked) {
      const { request = {} } = this.props;
      this.removeItemFromLocal(productCode);
      this.removeWishlistInLocal(productCode);
      this.setState({ productLiked: false, closetPop: false });
      this.closetInFlight = true;
      deferAfterPaint(() => {
        const reqQuery = { ...request.query };
        reqQuery.currentPage = 0;
        const query = buildQuery(reqQuery);
        const nextRequest = { ...request, query };
        Promise.resolve(this.props.removeFromWishlist(productCode, nextRequest))
          .then(response => {
            this.closetInFlight = false;
            if (response && response.statusCode !== 0) {
              this.revertClosetRemove();
            }
          })
          .catch(() => {
            this.closetInFlight = false;
            this.revertClosetRemove();
          });
      });
    } else if (isSignedIn) {
      this.addWishlistInLocal();
      this.setState({ productLiked: true, closetPop: true });
      this.closetInFlight = true;
      deferAfterPaint(() => {
        Promise.resolve(this.props.addToWishlistApi(sizeCodeAtClick))
          .then(response => {
            this.closetInFlight = false;
            const { statusCode } = response || {};
            const {
              API_FAILED_TO_ADD_ITEM_TO_WISHLIST,
              API_SERVICE_UNAVAILABLE,
              ITEM_DELISTED_FROM_SITE
            } = wishlistStatusCodes;
            if (
              statusCode === API_FAILED_TO_ADD_ITEM_TO_WISHLIST ||
              statusCode === API_SERVICE_UNAVAILABLE ||
              statusCode === ITEM_DELISTED_FROM_SITE
            ) {
              this.revertClosetAdd();
            }
          })
          .catch(() => {
            this.closetInFlight = false;
            this.revertClosetAdd();
          });
      });
    } else {
      this.props.showModal('sign-in-up');
      localStorage.setItem('prdCode', sizeCode);
      localStorage.setItem('prdColorGroup', productCode);
    }
    deferNonCriticalWork(() => {
      if (newDesignLuxe) {
        luxeEventPush({
          eventName: 'add_to_closet',
          event_action: 'add to closet'
        });
      } else {
        generateEvent({
          Event: 'AddToCloset',
          value: {
            SizeSelected: sizeCodeAtClick,
            Quantity: 1,
            Price,
            ProductId: baseProduct
          }
        });
        segmentEventPush({
          event: 'Product Wishlisted',
          //isGA4: true,
          wishlisted_source: 'add to closet',
          ecommerce: {
            //currency: 'INR',
            //value: Number(productPrice) || 0,
            items: [
              {
                  ...getProductItemPDP(dataSnapshot)
              }
            ]
          },
          //...eventPushObj.user_details
        });
        gtmEventPush({
          event: 'user_communication',
          event_category: 'user interactions',
          event_action: 'user_communication',
          event_label: !productLikedAtClick && 'Added to wishlist',
          product_size: selectedSizeName
        });
      }
      if (isSignedIn) {
        const ads = { brickCategory, brickSubCategory, brickName, code: pdCode, price: priceValue, quantity: 1 };
        if (wasLiked) jioAdsRemoveFromWishList(ads); else jioAdsAddtoWishList(ads);
      }
    });
  }

  addWishlistInLocal() {
    const { productCode } = this.props;
    let userId = signInCheck(true);
    let wishlistData = JSON.parse(localStorage.getItem('productWishlistStatusData'));
    if (!wishlistData || !userId || productCode === '') return false;
    const userWishlistData = wishlistData[userId];
    if (!userWishlistData) return false;
    const { codes = [], updatedOn } = userWishlistData;
    if (codes.length === 0 || !codes.includes(productCode)) codes.push(productCode);
    const localData = {
      updatedOn,
      codes
    };
    let finalResponse = wishlistData;
    finalResponse[userId] = localData;
    localStorage.setItem('productWishlistStatusData', JSON.stringify(finalResponse));
  }

  render() {
    const { productData, newDesignLuxe } = this.props;
    const { productLiked, closetPop } = this.state;
    const ajioFileName = 'pdp-wishlist-icon-desktop';
    const ajioIconName = productLiked ? `${ajioFileName}-active` : ajioFileName;
    return (
      <div className="save-to-closet-wrapper">
        <div
          className="btn-gray"
          onClick={() => this.saveToCloset(productData, productLiked)}
          tabIndex={0}
          role="button"
        >
          {newDesignLuxe ? (
            <span className="luxe-pdp-wishlist-desktop-icon" aria-label="wishlist">
              <span className={`${productLiked ? 'icon active' : 'icon'}${closetPop ? ' pdp-closet-pop' : ''}`} />
              wishlist
            </span>
          ) : (
            <span
              className={`pdp-wishlist-desktop-icon${closetPop ? ' pdp-closet-pop' : ''}`}
              aria-label={productLiked ? 'REMOVE FROM WISHLIST' : 'SAVE TO WISHLIST'}
            >
              <img
                src={`${imageBaseUrl}/static/img/${ajioIconName}.svg`}
                alt="" aria-hidden="true" 
              />
              {productLiked ? 'REMOVE FROM WISHLIST' : 'SAVE TO WISHLIST'}
            </span>
          )}
        </div>
      </div>
    );
  }
}
const mapStateToProps = state => {
  return {
    selectedSizeCode: state.product.selectedSizeCode,
    productCode: state.product?.productDetails?.code || '',
    request: state.request
  };
};

const mapDispatchToProps = dispatch => {
  return {
    addToWishlistApi: productId => dispatch(addProductToWishlist(productId)),
    showModal: name => {
      dispatch(showModal(name));
    },
    removeFromWishlist: (productCode, request) =>
      dispatch(removeProductFromWishlistPDP({ data: productCode, request })),
    loadWishlistOptionCodesAPI: () => {
      loadWishlistOptionCodesAPI();
    }
  };
};

export default SaveToCloset = connect(mapStateToProps, mapDispatchToProps)(SaveToCloset);
